import type { KnownMapping, SchemaField } from "@/types";

export function resolveApplyMappingTargetCol(m: KnownMapping, fields: SchemaField[]): string {
  if (m.targetFieldId) return m.targetFieldId;
  const byName = fields.find((f) => f.fieldName === m.targetField);
  return byName?.id ?? m.targetField;
}

export function buildApplyMappingsPayload(
  savedMappings: KnownMapping[],
  schemaFields: SchemaField[]
): {
  source_col: string;
  target_col: string;
  region_id?: string;
}[] {
  return savedMappings.map((m) => ({
    source_col: m.sourceField,
    target_col: resolveApplyMappingTargetCol(m, schemaFields),
    ...(m.regionId ? { region_id: m.regionId } : {}),
  }));
}
